module.exports = __webpack_public_path__ + "img/制御工学3_10.38ba4342.png";